import React from 'react';
import { Check } from 'lucide-react';
import { SeatsChart } from 'services/Seats/types';
import {
	ChartItemContainer,
	ChartThumbnail,
	ChartName,
	ChartStatus,
	SelectedIndicator,
} from '../../SeatsCharts.styles';

interface ChartItemProps {
	chart: SeatsChart;
	selected?: boolean;
	/**
	 * When true the selection is frozen (e.g. tickets already sold). The currently-selected
	 * chart stays highlighted but cannot be deselected, and non-selected charts are greyed out
	 * and non-interactive.
	 */
	locked?: boolean;
	onSelect?: (chart: SeatsChart) => void;
}

export const ChartItem: React.FC<ChartItemProps> = ({ chart, selected = false, locked = false, onSelect }) => {
	const handleClick = () => {
		// Frozen: neither switch to another chart nor deselect the current one.
		if (locked) return;
		onSelect?.(chart);
	};

	const stateClass = selected ? 'selected' : locked ? 'disabled' : '';

	return (
		<ChartItemContainer className={stateClass} onClick={handleClick}>
			{selected && (
				<SelectedIndicator>
					<Check size={14} strokeWidth={2.5} />
				</SelectedIndicator>
			)}
			<ChartThumbnail src={chart.publishedVersionThumbnailUrl} alt={chart.name} loading="lazy" />
			<ChartName>{chart.name}</ChartName>
			<ChartStatus className={chart.status.toLowerCase().replace('_', '-')}>
				{chart.status.replace('_', ' ')}
			</ChartStatus>
		</ChartItemContainer>
	);
};
